import { Navigate } from "react-router-dom";
import { useProfile } from "@/context/ProfileContext";
import { ChoosePlan, TrialBanner } from "@/components/Paywall";

export const homeFor = (role, learnerType) => (role === "teacher" ? "/teacher" : role === "admin" ? "/admin" : role === "parent" ? "/parent" : role === "daycare" ? "/daycare" : learnerType === "adult" ? "/pathway" : "/");

export const Loading = () => (
  <div className="py-32 grid place-items-center" data-testid="auth-loading">
    <div className="w-12 h-12 rounded-full bg-[#6B9080]/40 animate-pulse" />
  </div>
);

export const RequireRole = ({ role, children }) => {
  const { profile } = useProfile();
  if (profile === null) return <Loading />;
  if (!profile) return <Navigate to="/login" replace />;
  if (![].concat(role).includes(profile.role)) return <Navigate to={homeFor(profile.role)} replace />;
  if (profile.access && !profile.access.active) return <ChoosePlan />;
  return <><TrialBanner />{children}</>;
};
